import React, { useState } from 'react';
import Header from '../components/Header';
import { useBreadEvaluation } from '../context/BreadEvaluationContext';
import { FileTextIcon, TrashIcon, DownloadIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const HistoryPage: React.FC = () => {
  const navigate = useNavigate();
  const {
    evaluations,
    deleteEvaluation
  } = useBreadEvaluation();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  // Filter evaluations by date range
  const filteredEvaluations = evaluations.filter(evaluation => {
    if (!startDate && !endDate) return true;
    const evalDate = new Date(evaluation.date);
    const start = startDate ? new Date(startDate) : new Date(0);
    const end = endDate ? new Date(endDate) : new Date();
    return evalDate >= start && evalDate <= end;
  });
  // Calculate average score
  const averageScore = filteredEvaluations.length > 0 ? Math.round(filteredEvaluations.reduce((sum, evaluation) => sum + evaluation.totalScore, 0) / filteredEvaluations.length) : 0;
  const handleExport = () => {
    // In a real application, this would generate and download a CSV file
    alert('Exportação de dados será implementada em uma versão futura.');
  };
  return <div className="min-h-screen flex flex-col bg-gray-100" data-id="element-92">
      <Header data-id="element-93" />
      <main className="flex-grow container mx-auto px-4 py-8" data-id="element-94">
        <div className="max-w-5xl mx-auto" data-id="element-95">
          <div className="bg-white rounded-lg shadow-lg p-8 mb-8" data-id="element-96">
            <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-97">
              Histórico de Avaliações
            </h1>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-4" data-id="element-98">
              <div className="flex flex-col md:flex-row gap-4" data-id="element-99">
                <div data-id="element-100">
                  <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-101">
                    Data inicial
                  </label>
                  <input type="date" id="startDate" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500" data-id="element-102" />
                </div>
                <div data-id="element-103">
                  <label htmlFor="endDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-104">
                    Data final
                  </label>
                  <input type="date" id="endDate" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500" data-id="element-105" />
                </div>
              </div>
              <button onClick={handleExport} className="flex items-center bg-gray-800 hover:bg-gray-700 text-white py-2 px-4 rounded-md transition duration-200 mt-4 md:mt-0" data-id="element-106">
                <DownloadIcon size={18} className="mr-2" data-id="element-107" />
                Exportar CSV
              </button>
            </div>
            <div className="mb-8 bg-orange-50 rounded-lg p-6 border border-orange-100" data-id="element-108">
              <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-109">
                Resumo
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center" data-id="element-110">
                <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-111">
                  <p className="text-gray-500 text-sm mb-1" data-id="element-112">
                    Total de Avaliações
                  </p>
                  <p className="text-2xl font-bold text-gray-800" data-id="element-113">
                    {filteredEvaluations.length}
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-114">
                  <p className="text-gray-500 text-sm mb-1" data-id="element-115">Pontuação Média</p>
                  <p className="text-2xl font-bold text-orange-500" data-id="element-116">
                    {averageScore}
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-117">
                  <p className="text-gray-500 text-sm mb-1" data-id="element-118">Conformidade</p>
                  <p className="text-2xl font-bold text-gray-800" data-id="element-119">
                    {filteredEvaluations.filter(evaluation => evaluation.totalScore >= 100).length}{' '}
                    / {filteredEvaluations.length}
                  </p>
                </div>
              </div>
            </div>
            {filteredEvaluations.length > 0 ? <div className="overflow-x-auto" data-id="element-120">
                <table className="min-w-full border-collapse" data-id="element-121">
                  <thead data-id="element-122">
                    <tr className="bg-gray-50 text-left" data-id="element-123">
                      <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-124">
                        Amostra
                      </th>
                      <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-125">
                        Data / Hora
                      </th>
                      <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-126">
                        Pontuação
                      </th>
                      <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-127">
                        Classificação
                      </th>
                      <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-128">
                        Ações
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-129">
                    {filteredEvaluations.map(evaluation => <tr key={evaluation.id} className="hover:bg-gray-50" data-id="element-130">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-131">
                          {evaluation.sampleNumber}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-132">
                          {evaluation.date} às {evaluation.time}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-133">
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${evaluation.totalScore >= 130 ? 'bg-green-100 text-green-800' : evaluation.totalScore >= 100 ? 'bg-blue-100 text-blue-800' : evaluation.totalScore >= 70 ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`} data-id="element-134">
                            {evaluation.totalScore} / 130
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-135">
                          {evaluation.classification}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-136">
                          <div className="flex space-x-2" data-id="element-137">
                            <button onClick={() => navigate(`/results`)} className="text-blue-600 hover:text-blue-900" data-id="element-138">
                              <FileTextIcon size={18} data-id="element-139" />
                            </button>
                            <button onClick={() => deleteEvaluation(evaluation.id)} className="text-red-600 hover:text-red-900" data-id="element-140">
                              <TrashIcon size={18} data-id="element-141" />
                            </button>
                          </div>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div> : <div className="text-center py-8" data-id="element-142">
                <p className="text-gray-500" data-id="element-143">
                  Nenhuma avaliação encontrada para o período selecionado.
                </p>
              </div>}
          </div>
        </div>
      </main>
    </div>;
};
export default HistoryPage;